import React from 'react';

const Hero = () => {
  return (
    <header className="text-center mb-10 pt-6">
      <div className="inline-block bg-teal-50 text-teal-800 px-4 py-1.5 rounded-full text-sm font-semibold tracking-wide mb-6 uppercase">
        Personal Review
      </div>
      <h1 className="text-3xl sm:text-4xl md:text-5xl font-extrabold text-slate-900 leading-tight mb-6">
        "I love how this plant-based capsule supports my daily energy consistency after 55."
      </h1>
      <p className="text-xl sm:text-2xl text-slate-600 font-medium leading-relaxed max-w-2xl mx-auto">
        Supporting my energy for singing and social gatherings.
      </p>

      <div className="mt-8 flex items-center justify-center gap-4 text-sm text-slate-500">
        <img 
          src="https://media-manager-c.questera.ai/greta-media/bf058984a4ffdbb1bcf737e98ba89b4a0e9a3794368100afc61d724fc2136ffb549bddff932effd18582b107d1ceb382/images/aW1hZ2UvcG5n/ea72968f8a3f683b4a4bee26fef09f8e.png" 
          alt="Nancy" 
          className="w-12 h-12 rounded-full object-cover object-top border-2 border-teal-100" 
        />
        <div className="text-left">
          <p className="font-semibold text-slate-800">By Nancy M.</p>
          <p>Updated Today • 3 min read</p>
        </div>
      </div>
    </header>
  );
};

export default Hero;